// Write your code here
import './index.css'

const TabItem = props => {
  const {itemDetails, activeTabId, selectTabItem} = props
  const {tabId, displayText} = itemDetails
  const activeClass = activeTabId === tabId ? 'tab-btn active-item' : 'tab-btn'

  const onSelectTabItem = () => {
    selectTabItem(tabId)
  }

  return (
    <li>
      <button type="button" className={activeClass} onClick={onSelectTabItem}>
        {displayText}
      </button>
    </li>
  )
}

export default TabItem
